// Adapted from node-fft project by Joshua Wong and Ben Bryan
// https://github.com/vail-systems/node-fft
import { __DEV__ } from '../../constants'
import { fft } from './fft'
import { fftMag } from './mag'
import { smoothen } from './smoothing'
import { toInt16 } from './to-int-16'

export const getVisualization = ({
  sampleSize,
  data,
  sampleRate,
  position,
  maxInt
}) => {
  const isPowerOfTwo = sampleSize > 0 && (sampleSize & (sampleSize - 1)) === 0
  if (!isPowerOfTwo) {
    if (__DEV__)
      console.warn(
        `The argument "bars" must be a power of two. For example: 64, 128. Got instead: ${sampleSize}`
      )
    return []
  }

  if (typeof position !== 'number') {
    if (__DEV__) console.warn('The argument "position" is not a valid number')
    return []
  }

  if (data.length < sampleSize) {
    if (__DEV__)
      console.warn(
        'Audio data is not big enough to provide ' + sampleSize + ' bars.'
      )
    return []
  }

  const start = Math.floor(position * sampleRate)

  const actualStart = Math.max(0, start - sampleSize / 2)

  const ints = new Int16Array({
    length: sampleSize
  })
  ints.set(
    data.subarray(actualStart, actualStart + sampleSize).map(x => toInt16(x))
  )
  const phasors = fft(ints)
  const magnitudes = fftMag(phasors).map(p => p)

  return smoothen(magnitudes).map(m => m / (sampleSize / 2) / maxInt)
}
